import {
  Box,
  CircularProgress,
  Container,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import 'react-credit-cards/es/styles-compiled.css'
import { BiUserCircle } from 'react-icons/bi'
import { useHistory } from 'react-router-dom'
import {
  StatusEtapaEnum,
  Pagamento as PagamentoType,
  StatusEtapaPagamentoEnum,
  registrarCliqueSeguro
} from 'src/api/pagamento'
import { Alert } from '@material-ui/lab'
import FormDadosPessoais from 'src/components/pagamento/formDadosPessoais'
import Steps, { IStepItem } from 'src/components/pagamento/steps'
import Button from 'src/components/ui/Button'
import UBox from 'src/components/ui/Ubox'
import { T_FORMAS_PAGAMENTO } from 'src/contexts/Pagamento/context'
import {
  IOpcaoFluxoPagamento,
  OPCOES_FLUXO_PAGAMENTO,
  OPCOES_FLUXO_PAGAMENTO_MAP
} from 'src/core/consts/opcoesFluxoPagamento'
import { SynRoutes } from 'src/core/consts/synRoutes'
import useAuth from 'src/hooks/useAuth'
import usePagamento from 'src/hooks/usePagamento'
import { useQueryParams } from 'src/hooks/useQuery'
import ComoFuncionaPagamento from './comoFuncionaPagamento'
import Pagamento from './pagamento'

const FORMA_PAGAMENTO = {
  PIX: 'pix' as T_FORMAS_PAGAMENTO,
  CARTAO_CREDITO: 'credit_card' as T_FORMAS_PAGAMENTO,
  BOLETO: 'boleto' as T_FORMAS_PAGAMENTO,
  MULTIPLAS: 'multiplas' as T_FORMAS_PAGAMENTO
}

const ARRAY_FORMA_PAGAMENTO = [
  {
    tipo: 'pix',
    icone: <i className="fa fa-brands fa-pix "></i>,
    nome: 'Pix'
  },
  {
    tipo: 'credit_card',
    icone: <i className="fa fa-solid fa-credit-card "></i>,
    nome: 'Cartão de crédito'
  },
  {
    tipo: 'boleto',
    icone: <i className="fa fa-solid fa-barcode "></i>,
    nome: 'Boleto'
  },
  {
    tipo: 'multiplas',
    icone: <i className="fa fa-square-plus"></i>,
    nome: 'Multiplas formas de pagamento'
  }
]

const padrao = {
  background: '#fff',
  borderRadius: '8px'
  // boxShadow: '1px 1px 8px #ddd'
}

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // margin: '30px auto',
    // margin: '0 ',
    padding: 0,
    // gap: '40px',
    '& .card-pagamento': {
      ...padrao
    },
    '& .item-selecionado': {
      ...padrao,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      // minHeight: '72px',
      marginBottom: '30px',
      lineHeight: '1.1em'
      // background: '#eee',
      // borderRadius: '8px',
      // borderBottom: '1px solid #ddd',
      // borderRight: '1px solid #ddd',
    },
    '& .logo-container': {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  boxResumo: {
    ...padrao,
    width: '440px',
    marginLeft: theme.spacing(4),
    marginBottom: theme.spacing(6)
  },
  boxPagamento: {
    // ...padrao,
    width: 'calc(100% - 480px)',
    // width: '60%'
    background: '#fff',
    borderRadius: '8px',
    // border: '1px solid #eee'
    boxShadow: '0px 0px 8px #ddd',
    marginBottom: '40px'
  },
  boxPagamentoDetalhe: {
    ...padrao,
    // maxWidth: '700px',
    width: '100%',
    '& .qr-code': {
      maxWidth: '210px'
    },
    '& .box-instructions p': {
      width: 'calc(100% - 48px)'
    },
    '& .icon-instructions': {
      background: theme.palette.secondary.main,
      color: '#fff',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 20,
      marginRight: '8px'
    },
    '& .back-green': {
      background: '#1cc3a5'
      // background: '#1cc332'
    },
    '& .text-green': {
      color: '#1cc3a5'
      // color: '#1cc332',
    }
  },
  boxFormaPagamento: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',

    '& .item': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '180px',
      gap: '8px',
      minHeight: '84px',
      background: '#eee',
      borderRadius: '8px',
      cursor: 'pointer',
      textAlign: 'center',
      // borderBottom: '1px solid #ddd',
      // borderRight: '1px solid #ddd',

      '&:hover': {
        background: theme.palette.secondary.main,
        color: '#fff'
      },

      '&:last-child': {
        // borderRight: 'none'
      }
    }
  },
  [theme.breakpoints.down(1401)]: {
    boxFormaPagamento: {
      flexDirection: 'column',
      '& .item': {
        width: '100%'
      }
    }
  },
  [theme.breakpoints.down('md')]: {
    container: {
      // display: 'flex',
      // alignItems: 'start',
      // justifyContent: 'start',
      // flexDirection: 'column',
      gap: '0px',
      margin: 0,
      padding: 0,
      '& .logo-container': {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between'
      }
    },
    boxResumo: {
      ...padrao,
      marginLeft: 0,
      width: '100%',
      // maxWidth: '700px',
      order: 1,
      marginBottom: 0
    },
    boxPagamento: {
      // ...padrao,
      width: '100%',
      order: 2,
      marginBottom: 0
    },
    boxFormaPagamento: {
      flexDirection: 'column',
      '& .item': {
        width: '100%'
      }
    }
  }
}))

const TITULO_ETAPAS = {
  DADOS_PESSOAIS_NF: 'Dados pessoais NF',
  DADOS_DE_PAGAMENTO: 'Dados de pagamento',
  CONCLUIR_PAGAMENTO: 'Concluir pagamento'
}

export default function PagePagamento() {
  const styles = useStyles()
  const theme = useTheme()
  const query = useQueryParams()
  const history = useHistory()
  const { signed } = useAuth()

  const {
    loadingResumo,
    loadingPagamento,
    loading,
    obterResumoPagamento,
    urlPix,
    boleto,
    formaPagamento,
    selecionarFormaPagamento,
    resumo,
    existePagamentoFracionado,
    reiniciarContext,
    activeStep,
    setActiveStep,
    opcaoFluxoEscolhida,
    setOpcaoFluxoEscolhida,
    limparFracionado
  } = usePagamento()

  const [primeiroLoading, setPrimeiroLoading] = useState(true)
  const [etapaTransicao, setEtapaTransicao] = useState<{
    de: number
    para: number
    nomeEtapa?: string
  } | null>(null)

  const ehXS = useMediaQuery(theme.breakpoints.down('sm'))

  const propostaId = query.get('p')
  const fluxo = query.get('fluxo')

  function handleChangeStep(nextStep: number) {
    const mudouProximaEtapaAtiva = nextStep > activeStep
    if (mudouProximaEtapaAtiva) {
      limparFracionado()
    }
    setActiveStep(nextStep)
  }

  function handleStepDadosPessoais() {
    handleChangeStep(0)
  }

  function handleStepClick(stepIndex: number) {
    handleChangeStep(stepIndex)
  }

  const getSteps = (): (string | IStepItem)[] => {
    if (!resumo) {
      return [TITULO_ETAPAS.DADOS_PESSOAIS_NF, TITULO_ETAPAS.DADOS_DE_PAGAMENTO]
    }
    const versao = resumo.versaoPagamento

    if (versao === 'v1' || versao === 'v2') {
      return [TITULO_ETAPAS.DADOS_PESSOAIS_NF, TITULO_ETAPAS.DADOS_DE_PAGAMENTO]
    }

    if (versao === 'v2.1') {
      let pagamentoIniciado =
        !!resumo?.existeEtapasDB && !resumo?.existeEtapaProvisoria
      let pagamentoAVista =
        opcaoFluxoEscolhida?.valor === 'total_a_vista' ||
        (!opcaoFluxoEscolhida &&
          resumo?.etapas?.length === 1 &&
          resumo?.etapas[0]?.pedidos?.some(
            (pedido: PagamentoType) => !!pedido.integral
          ))

      if (pagamentoAVista) {
        if (pagamentoIniciado && !opcaoFluxoEscolhida) {
          setOpcaoFluxoEscolhida(OPCOES_FLUXO_PAGAMENTO_MAP.AVISTA)
        }
        const stepsArr: (string | IStepItem)[] = [
          TITULO_ETAPAS.DADOS_PESSOAIS_NF,
          TITULO_ETAPAS.CONCLUIR_PAGAMENTO
        ]
        if (resumo.aceitaSeguro && resumo.foraDoCorteSeguro && !!resumo.linkGoogleFormsSeguro) {
          stepsArr.push({
            titulo: 'Proteção opcional',
            status: StatusEtapaEnum.Pendente
          } as IStepItem)
        }
        return stepsArr
      }

      if (!pagamentoAVista && resumo?.etapas?.length) {
        if (
          (pagamentoIniciado && !opcaoFluxoEscolhida) ||
          (!pagamentoIniciado &&
            !opcaoFluxoEscolhida &&
            resumo?.etapas?.length === 1)
        ) {
          setOpcaoFluxoEscolhida(OPCOES_FLUXO_PAGAMENTO_MAP.PARCELADO)
        }
        const etapaAtualIndex = resumo.etapaAtual ?? 0

        const etapasComStatus: IStepItem[] = resumo.etapas.map(
          (etapa, index) => {
            var status =
              index < etapaAtualIndex ? StatusEtapaEnum.Pago : etapa.status

            return {
              titulo: etapa.titulo,
              status: status
            }
          }
        )

        var dadosPessoaisCompletos = !!resumo.dadosPessoais?.cep

        const stepsArr: (string | IStepItem)[] = [
          {
            titulo: TITULO_ETAPAS.DADOS_PESSOAIS_NF,
            status: dadosPessoaisCompletos
              ? StatusEtapaEnum.Pago
              : StatusEtapaEnum.Pendente
          } as IStepItem,
          ...etapasComStatus
        ]

        if (resumo.aceitaSeguro && resumo.foraDoCorteSeguro && !!resumo.linkGoogleFormsSeguro) {
          stepsArr.push({
            titulo: 'Proteção opcional',
            status: StatusEtapaEnum.Pendente
          } as IStepItem)
        }

        return stepsArr
      }
    }

    return null
  }

  const steps = getSteps()

  function start() {
    reiniciarContext()
    if (!propostaId) {
      setPrimeiroLoading(false)
      return
    }

    obterResumoPagamento(propostaId).then(carregou =>
      setPrimeiroLoading(!carregou)
    )
  }

  function navegarParaPainel() {
    history.push(`${SynRoutes.home}`)
  }

  useEffect(() => {
    if (primeiroLoading) return

    const seguroDisponivel = resumo?.aceitaSeguro && resumo?.foraDoCorteSeguro && !!resumo?.linkGoogleFormsSeguro

    if (!!resumo?.pago && !seguroDisponivel) {
      history.replace(`${SynRoutes.acompanharPagamento}?p=${propostaId}`)
    }

    let pagamentoIniciado =
      !!resumo?.existeEtapasDB && !resumo?.existeEtapaProvisoria
    if (resumo?.versaoPagamento === 'v2.1' && pagamentoIniciado) {
      const proximoStep = (resumo?.etapaAtual ?? 0) + 1
      if (proximoStep > activeStep) {
        const stepsArray = getSteps()
        const step = stepsArray?.[proximoStep]
        const nomeEtapa =
          step != null
            ? typeof step === 'string'
              ? step
              : (step as IStepItem).titulo
            : undefined
        setEtapaTransicao({ de: activeStep, para: proximoStep, nomeEtapa })
      }
      handleChangeStep(proximoStep)
    }
  }, [resumo, primeiroLoading, propostaId])

  useEffect(() => {
    if (!etapaTransicao) return

    const timeout = setTimeout(() => {
      setEtapaTransicao(null)
    }, 10000)

    return () => clearTimeout(timeout)
  }, [etapaTransicao])

  const opcaoVoltarMostrarComoFunciona =
    resumo?.versaoPagamento === 'v2.1' &&
    (resumo?.existeEtapasDB === false || resumo?.existeEtapaProvisoria)

  const [mostrarComoFunciona, setMostrarComoFunciona] = useState<
    boolean | null
  >(null)

  useEffect(() => {
    if (!resumo) return

    if (resumo.dadosRecebedorIncompleto) {
      if (mostrarComoFunciona !== true) {
        setMostrarComoFunciona(true)
      }
      if (opcaoFluxoEscolhida) {
        setOpcaoFluxoEscolhida(null)
      }
      return
    }

    var mostrar =
      resumo?.versaoPagamento === 'v2.1' &&
      (resumo?.existeEtapasDB === false || resumo?.existeEtapaProvisoria) &&
      resumo?.etapas?.length > 1 &&
      !opcaoFluxoEscolhida &&
      !fluxo

    if (mostrar !== mostrarComoFunciona) {
      setMostrarComoFunciona(mostrar)
    }
  }, [
    resumo?.versaoPagamento,
    resumo?.existeEtapasDB,
    resumo?.existeEtapaProvisoria,
    resumo?.etapas?.length,
    resumo?.dadosRecebedorIncompleto,
    opcaoFluxoEscolhida,
    fluxo
  ])

  function handleOpcaoFluxoEscolhida(opcao: IOpcaoFluxoPagamento) {
    setOpcaoFluxoEscolhida(opcao)
    setActiveStep(0)
  }

  useEffect(() => {
    start()
  }, [])

  useEffect(() => {
    if (resumo?.dadosRecebedorIncompleto) return
    if (fluxo && !opcaoFluxoEscolhida) {
      const opcao = OPCOES_FLUXO_PAGAMENTO.find(o => o.valor === fluxo)
      if (opcao) setOpcaoFluxoEscolhida(opcao)
    }
  }, [fluxo, resumo?.dadosRecebedorIncompleto])

  if (primeiroLoading || (resumo?.pago && !(resumo?.aceitaSeguro && resumo?.foraDoCorteSeguro && !!resumo?.linkGoogleFormsSeguro)) || mostrarComoFunciona === null) {
    return (
      <UBox
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh'
        }}
      >
        <Box textAlign="center">
          <CircularProgress />
          <div>Carregando...</div>
        </Box>
      </UBox>
    )
  }

  return (
    <UBox>
      {/* <Box mb={2}>
        <Typography variant="h5">Pagamento</Typography>
      </Box> */}

      <Container maxWidth="lg" className={styles.container}>
        <UBox className="logo-container">
          {!ehXS && <UBox m={2} mb={2} width={ehXS ? '120px' : '180px'}></UBox>}
          <UBox m={2} mb={2}>
            <img
              src="/image/logo-horizontal.png"
              alt="logo syn saúde"
              width={ehXS ? '110' : '136'}
            // width={ehXS ? '46' : '56'}
            // style={{
            //   marginTop: ehXS && activeStep === 0 ? '16px' : '0'
            // }}
            />
          </UBox>
          <UBox
            style={{
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end'
            }}
            m={2}
            mb={2}
            width={ehXS ? '120px' : '180px'}
          >
            {signed ? (
              <Typography
                style={{
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'end',
                  cursor: 'pointer'
                }}
                color="primary"
                onClick={navegarParaPainel}
              >
                <BiUserCircle
                  style={{ fontSize: '2rem', marginRight: '8px' }}
                />
                {!ehXS && 'Minha conta'}
              </Typography>
            ) : (
              <Button variant="contained" onClick={navegarParaPainel}>
                Entrar
              </Button>
            )}
          </UBox>
        </UBox>
        {mostrarComoFunciona ? (
          <ComoFuncionaPagamento onOpcaoEscolhida={handleOpcaoFluxoEscolhida} />
        ) : (
          <UBox pb={6} className={styles.boxPagamento}>
            <Steps
              opcaoVoltarMostrarComoFunciona={opcaoVoltarMostrarComoFunciona}
              handleVoltarMostrarComoFunciona={() => {
                handleOpcaoFluxoEscolhida(null)
              }}
              activeStep={activeStep}
              handleStep1={handleStepDadosPessoais}
              steps={steps}
              onStepClick={handleStepClick}
            />
            <UBox render={activeStep === 0} p={3}>
              <FormDadosPessoais
                mostrarComoFunciona={opcaoVoltarMostrarComoFunciona}
                handleVoltar={() => {
                  handleOpcaoFluxoEscolhida(null)
                }}
                handleNextStep={() => {
                  if (steps.length > 1) {
                    handleChangeStep(1)
                  }
                }}
              />
            </UBox>

            {activeStep > 0 && (
              <UBox p={3}>
                {steps[activeStep] && (typeof steps[activeStep] === 'string' ? steps[activeStep] : (steps[activeStep] as IStepItem).titulo) === 'Proteção opcional' ? (
                  <Box className={styles.boxPagamentoDetalhe} style={{ padding: '8px 0' }}>
                    {/* Hero section */}
                    <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
                      <Box style={{ flex: 1, paddingRight: 24 }}>
                        <Typography
                          variant="overline"
                          style={{ color: '#1cc3a5', fontWeight: 700, letterSpacing: 1, fontSize: '0.7rem', display: 'block', marginBottom: 8 }}
                        >
                          PROTEÇÃO OPCIONAL PARA O SEU PROCEDIMENTO
                        </Typography>
                        <Typography variant="h5" style={{ fontWeight: 700, color: '#1a1a2e', lineHeight: 1.3, marginBottom: 12 }}>
                          Seu procedimento é elegível para uma proteção financeira.
                        </Typography>
                        <Typography variant="body2" style={{ color: '#555', lineHeight: 1.6 }}>
                          Você pode contratar uma proteção financeira para cirurgias, cobrindo ou reembolsando possíveis custos extras decorrentes de complicações e intercorrências.
                        </Typography>
                      </Box>
                      {/* Shield icon */}
                      <Box style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', width: 180, height: 180 }}>
                        <img src="/image/seguro/escudo-seguro.png" alt="Proteção Financeira" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                      </Box>
                    </Box>

                    {/* Benefits card */}
                    <Box style={{ background: '#f5fbfa', border: '1px solid #d0f0ea', borderRadius: 12, padding: '20px 24px', marginBottom: 24, display: 'flex', alignItems: 'flex-start', gap: 20 }}>
                      <Box style={{ flexShrink: 0, width: 100, height: 100, marginTop: 2 }}>
                        <img src="/image/seguro/planilha-seguro.png" alt="Benefícios" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                      </Box>
                      <Box>
                        <Typography variant="body2" style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: 10 }}>
                          O que essa proteção pode oferecer:
                        </Typography>
                        {[
                          'Ajuda financeira em intercorrências cobertas',
                          'Mais tranquilidade no pós-operatório',
                          'Atendimento da equipe especializada'
                        ].map((item, i) => (
                          <Box key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                            <img src="/image/seguro/check-svgrepo-com.svg" alt="ok" style={{ width: 18, height: 18, flexShrink: 0 }} />
                            <Typography variant="body2" style={{ color: '#444' }}>{item}</Typography>
                          </Box>
                        ))}
                      </Box>
                    </Box>

                    {/* Disclaimer notes */}
                    <Box style={{ marginBottom: 28 }}>
                      <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
                        <img src="/image/seguro/shield-check-svgrepo-com.svg" alt="proteção" style={{ width: 18, height: 18, flexShrink: 0, marginTop: 2 }} />
                        <Typography variant="caption" style={{ color: '#666', lineHeight: 1.6 }}>A contratação é opcional e não interfere na confirmação da sua cirurgia.</Typography>
                      </Box>
                      <Box style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10 }}>
                        <img src="/image/seguro/chat-bubbles-svgrepo-com.svg" alt="contato" style={{ width: 18, height: 18, flexShrink: 0, marginTop: 2 }} />
                        <Typography variant="caption" style={{ color: '#666', lineHeight: 1.6 }}>Ao clicar abaixo, nossa equipe entrará em contato para explicar os detalhes, valores e condições antes de qualquer decisão.</Typography>
                      </Box>
                    </Box>

                    {/* Action buttons */}
                    <Box style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                      <Button
                        variant="contained"
                        onClick={async () => {
                          try {
                            if (propostaId) {
                              await registrarCliqueSeguro(propostaId as string);
                              history.push(`${SynRoutes.acompanharPagamento}?p=${propostaId}`)
                            }
                          } catch (error) {
                            console.error('Erro ao registrar clique de seguro', error);
                          }
                          window.open(resumo.linkGoogleFormsSeguro, '_blank');
                        }}
                        style={{ background: '#1cc3a5', color: '#fff', fontWeight: 600, borderRadius: 8, padding: '14px 28px', flex: 1, minWidth: 220, boxShadow: 'none', textTransform: 'none', fontSize: '0.95rem' }}
                      >
                        Quero saber mais sobre a proteção
                      </Button>
                      <Button
                        variant="text"
                        onClick={() =>
                          history.push(`${SynRoutes.acompanharPagamento}?p=${propostaId}`)
                        }
                        style={{ borderColor: '#bbb', color: '#333', borderRadius: 8, padding: '14px 28px', flex: 1, minWidth: 180, textTransform: 'none', fontSize: '0.95rem' }}
                      >
                        Continuar sem contratar
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Pagamento
                    embutido
                    etapaTransicao={etapaTransicao}
                    handleBackStep={() => {
                      handleChangeStep(activeStep - 1)
                    }}
                  />
                )}
              </UBox>
            )}
          </UBox>
        )}
      </Container>
    </UBox>
  )
}
